import { createContext } from 'react';

export interface CodeWidgetHostActions {
  /** Submit a chat question — clears the active page and starts a new chat session */
  submitQuery?: (query: string) => void;
  /** Open a profile-scoped chat session */
  viewProfile?: (profileId: string, name: string) => void;
  // Future actions can be added here as optional members
}

/**
 * Carries host action callbacks from Chat.tsx down to code widgets via the
 * React context tree. Defaults to an empty object so that widgets rendered
 * without a provider (e.g. in the builder preview) silently no-op.
 */
export const CodeWidgetHostActionsContext = createContext<CodeWidgetHostActions>({});
